import SjQuestionFileAdd from '../sj-question-file/src/SjQuestionFileAdd.vue'

export default SjQuestionFileAdd



// WEBPACK FOOTER //
// ./src/views/question-editor/packages/sj-question-file-add/index.js